<template>
    <div class="relative isolate px-4 sm:px-6 pt-8 lg:px-8 mt-18">
        <div class="mx-auto max-w-7xl py-8 sm:py-12 lg:py-16">
            <div class="flex flex-col lg:flex-row items-center justify-between">
                <!-- Left column: Main content -->
                <div class="text-center lg:text-left w-full lg:w-1/2 mb-8 lg:mb-0 lg:pr-8">
                    <h1 class="text-5xl leading-tight font-bold tracking-tight text-gray-900 mb-4">
                        <span v-if="agency">Influencer management</span>
                        <span v-else>Promote your</span>
                        <br />
                        <div class="inline-flex flex-col items-center lg:items-start overflow-hidden text-center h-[60px]">
                          <div v-if="agency">
                            for agencies
                          </div>
                          <template v-else>
                            <div v-for="(type, index) in businessTypes" :key="index"
                                 :class="['slide-up bg-green-100 rounded-lg px-0.5 md:px-4', { 'active': currentIndex === index }]"
                                 :style="{ transform: `translateY(-${currentIndex * 100}%)` }">
                              {{ type }}
                            </div>
                          </template>
                        </div>
                        <br />
                        <span v-if="!agency">with local influencers</span>
                    </h1>
                    <p class="mt-2 sm:mt-4 text-sm sm:text-base leading-6 sm:leading-7 text-gray-600 mb-4 sm:mb-6">
                        Discovery, campaign management and reporting  <br />
                        to help you deliver results for clients.
                    </p>
                    <div
                        class="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 sm:gap-6 mb-4">
                        <a href="/business/signup"
                            class="w-full sm:w-auto text-sm rounded-md bg-indigo-600 px-4 py-2 font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                            Start your free trial
                        </a>
                        <a href="https://calendly.com/bulba/30-min-call" target="_blank"
                            class="text-sm font-semibold leading-6 text-gray-900">
                            Book a demo <span aria-hidden="true">→</span>
                        </a>
                    </div>
                    <p class="text-xs sm:text-sm text-gray-600 mb-2 mt-8">Trusted for over 10,000 collaborations</p>

                    <Brands id="brands" class="mb-8 lg:mb-0" />
                </div>
                <!-- Right column: Image showcase -->
                <div class="relative w-full lg:w-1/2">
                    <div class="relative overflow-hidden rounded-xl shadow-[0_0_40px_4px_rgba(21,12,36,0.18)]">
                        <img :src="desktopUI" alt="desktop ui" class="w-full h-auto object-cover object-left" />
                    </div>
                    <img :src="mobileUI" alt="mobile ui"
                        class="absolute right-0 bottom-0 w-1/3 border-4 border-white overflow-hidden rounded-xl shadow-[0_0_20px_10px_rgba(71,52,86,0.18)]" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import mobileUI from '@/assets/img/mobile_ui.jpg'
import desktopUI from '@/assets/img/desktop_ui.jpg'
import Brands from '@/pages/home/Brands.vue'
import { ref, onMounted, onUnmounted } from 'vue'

const props = withDefaults(defineProps<{agency: boolean}>(), {agency: false})

const businessTypes = ref(['restaurant', 'bar', 'event', 'activity', 'concert', 'workshop', 'class', 'escape room', 'attraction park', 'immersive experience'])
const currentIndex = ref(0)

let intervalId

const startAnimation = () => {
  intervalId = setInterval(() => {
    currentIndex.value = (currentIndex.value + 1) % businessTypes.value.length
  }, 2000)
}

onMounted(() => {
  startAnimation()
})

onUnmounted(() => {
  clearInterval(intervalId)
})
</script>


<style scoped>
.slide-up {
  transition: transform 1s ease;
}

.active {
  transition-delay: 0.1s;
}
</style>
